<template>
  <li class="sm-plan-details__content-list-item">
    <span class="sm-plan-details__content-list-item-title">{{featureModifiedTitle(feature)}}</span>
    <span 
      v-if="!feature.available"
      class="disabled"
    >N/A</span>
    <span v-else-if="feature.unlimited">Unlimited</span>
    <span 
      v-else-if="feature.type != 'boolean'"
      class="sm-plan-details__content-list-item-value"
    >
      <template v-if="feature.type == 'price'">
        {{formatPrice(feature.value)}}
      </template>
      <template v-else-if="feature.type == 'flagged'">
        <template v-if="feature.flag">{{formatPrice(feature.value)}}</template>
        <template v-else>{{feature.value}}%</template>
      </template>
      <template v-else-if="feature.type == 'mixed'">
        <template v-if="feature.value && feature.value !== 0">{{formatPrice(feature.alt_value)}}</template>
        <template v-else-if="feature.alt_value">{{feature.value}}%</template>
        <template v-else>0</template>
      </template>
      <template v-else-if="feature.type == 'raw'">
        {{feature.value}}
      </template>
      <template v-else>
        {{`${feature.value} ${feature.type}`}}
      </template>
      
      <template v-if="feature.suffix">
        {{`/ ${feature.suffix}`}}
      </template>
    </span>
    <span
      v-else
      class="sm-plan-details__content-list-item-enabled"
    >
      <span v-if="feature.value" class="check"></span>
      <span v-else class="cross"></span>
    </span>
  </li>
</template>

<script>
import {FormatPrice} from '@/utils/general-data';
import { mapGetters } from 'vuex';

export default {
  name: 'details-elem',
  props: {
    feature: {
      type: Object,
      required: true
    },
    providerCountry:{
      type: String,
      default:'United States'
    }
  },
  computed:{
    ...mapGetters({
      provider: 'provider',
    })
  },
  methods: {
    formatPrice: FormatPrice,
    featureModifiedTitle(feature) {
      if(feature.field && feature.field === 'registered_agent_service_price' && this.providerCountry ===  "Australia"){
        return 'Public Officer service'
      }

      return feature.title
    }
  }
}
</script>